import React from 'react';
import get from 'lodash/get';
import { LazyImage } from 'project/lazy-image';
import { LiveArrowControl, controlTypes } from 'components/live-arrow-control';
import LiveTabsNav from 'components/live-tabs/js/live-tabs-nav';

const LiveHoleHero = (props) => {
    const { hole, isExpanded } = props;
    const overviewText = get(hole, 'sitecoreData.overviewText', '');
    const overviewShortText = get(hole, 'sitecoreData.overviewShortText', '');
    const moreText = isExpanded ? 'Less' : 'More';

    return (
        <div className="live-hole-hero">
            <div className="live-hole-hero__background">
                <LazyImage image={'/-/media/Images/live-hole-hero-bg.jpg'} />
            </div>
            <div className="live-hole-hero__container">
                <h2 className="live-hole-hero__title">
                    <span>Hole</span>
                    <span className="live-hole-hero__hole-num">{hole.id}</span>
                </h2>
                <div className="live-hole-hero__overview-text">
                    {!isExpanded && <div dangerouslySetInnerHTML={{ __html: overviewShortText }} />}
                    {isExpanded && <div dangerouslySetInnerHTML={{ __html: overviewText }} />}
                    <button
                        className="live-hole-hero__more copy"
                        type="button"
                        onClick={props.onClickToggleOverview}>{moreText}</button>
                </div>
                < div className="live-hole-hero__controls-content">
                    <div className="live-hole-hero__tabs-wrapper">
                        <LiveTabsNav
                            tabs={props.tabs}
                            activeTabId={props.activeTabId}
                            onTabClick={props.setTab}
                        />
                    </div>
                    <div className="live-hole-hero__arrow-controls-wrapper">
                        <LiveArrowControl
                            mode={'hole'}
                            holesLength={props.holesLength}
                            holeId={props.hole.id}
                            type={controlTypes.prev}
                            renderHole={props.renderHole}
                        />
                        <LiveArrowControl
                            mode={'hole'}
                            holesLength={props.holesLength}
                            holeId={props.hole.id}
                            type={controlTypes.next}
                            renderHole={props.renderHole}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LiveHoleHero;
